const lineChartDataScreens = {
  series: [
    {
      name: '800x600',
      data: [
        40,43,44,41,36,28,26,28,32,35,33,34,29,26,28,35,38,41,40,32,33,39,42,44,41,40,32,28,37,41,41
      ]
    },
    {
      name: '1280x768',
      data: [
        48,
        51,
        53,
        49,
        43,
        33,
        30,
        33,
        38,
        42,
        39,
        40,
        33,
        30,
        32,
        42,
        45,
        49,
        47,
        37,
        38,
        46,
        51,
        53,
        50,
        49,
        37,
        33,
        44,
        49,
        50
      ]
    },
    {
      name: '1336x778',
      data: [
        30,
        32,
        34,
        34,
        36,
        40,
        48,
        44,
        46,
        42,
        40,
        38,
        36,
        40,
        42,
        46,
        44,
        41,
        40,
        36,
        38,
        40,
        40,
        48,
        42,
        36,
        48,
        42,
        44,
        32,
        45
      ]
    },
    {
      name: '1920x1440',
      data: [
        50,
        55,
        56,
        65,
        70,
        68,
        64,
        65,
        56,
        46,
        59,
        57,
        61,
        63,
        58,
        60,
        64,
        48,
        50,
        52,
        54,
        63,
        54,
        52,
        59,
        56,
        57,
        56,
        55,
        57,
        59
      ]
    }
  ],
  xAxis: {
    categories: [
      '12/18/17',
      '12/19/17',
      '12/20/17',
      '12/21/17',
      '12/22/17',
      '12/23/17',
      '12/24/17',
      '12/25/17',
      '12/26/17',
      '12/27/17',
      '12/28/17',
      '12/29/17',
      '12/30/17',
      '12/31/17',
      '1/1/18',
      '1/2/18',
      '1/3/18',
      '1/4/18',
      '1/5/18',
      '1/6/18',
      '1/7/18',
      '1/8/18',
      '1/9/18',
      '1/10/18',
      '1/11/18',
      '1/12/18',
      '1/13/18',
      '1/14/18',
      '1/15/18',
      '1/16/18',
      '1/17/18'
    ]
  },
  yAxis: {
    title: {
      text: 'Users'
    }
  }
};

export default lineChartDataScreens;



// WEBPACK FOOTER //
// ./src/data/lineChartDataScreens.js